import React from 'react';
import { Avatar } from '@/components';
import { ReplyCommentType } from '../../../const';
import { getCommentAuthor } from '../../../util';
import { humanTimeDate } from '@/libs/dayjs';

type ReplyCommentProps = {
  replyComment: ReplyCommentType;
  fullName: string;
};
export const ReplyComment = (props: ReplyCommentProps) => {
  const { replyComment, fullName } = props;
  const _user = replyComment?.facebook_comment_info
    ? {
        fullname: replyComment?.facebook_comment_info?.facebook_user.first_name || '',
        avatar: replyComment?.facebook_comment_info?.facebook_user.avatar_url || '',
      }
    : null;
  const { fullname: replyName, avatar } = getCommentAuthor(
    _user ? _user : null,
    replyComment?.staffs ? replyComment?.staffs : null
  );
  return (
    <div className="tw-flex tw-gap-x-2" key={'reply-comment-' + replyComment?.id}>
      <Avatar alt={replyName} src={avatar || ''} className="tw-w-5 tw-h-5" rounded="tw-rounded-full" />
      <div className="tw-bg-white  tw-px-4 tw-py-1 tw-rounded-b-lg tw-rounded-lg tw-relative tw-flex-1">
        <h4
          dangerouslySetInnerHTML={{ __html: replyName }}
          className="text-user-chat tw-font-normal tw-text-13 tw-line-clamp-1"
        />
        <p className="tw-text-secondary-70 tw-text-13">
          <b>{fullName}</b> <span dangerouslySetInnerHTML={{ __html: replyComment?.comment || '' }}></span>
        </p>
        {replyComment?.updated_at && (
          <div
            className={`tw-text-right tw-text-secondary-50`}
            style={{
              fontSize: '10px',
            }}
          >
            {humanTimeDate(replyComment?.updated_at)}
          </div>
        )}
      </div>
    </div>
  );
};
